var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 33,
    viewBox: "0 0 9 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C93D0B",
    d: "M7.06 32.102V3.53C7.06 1.58 5.478 0 3.53 0 1.58 0 0 1.58 0 3.53v28.572h7.06zM4.384 2.818c0 .472-.383.855-.856.855-.471 0-.855-.383-.855-.855 0-.473.384-.855.855-.855.473 0 .856.382.856.855z",
    transform: "translate(.957 .003)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4BB7C",
    d: "M.988 18.311H0v.844h.988c.233 0 .422-.189.422-.422 0-.233-.189-.422-.422-.422M1.41 20.806c0-.233-.189-.422-.422-.422H0v.844h.988c.233 0 .422-.19.422-.422M.988 24.53H0v.843h.988c.233 0 .422-.189.422-.422 0-.233-.189-.422-.422-.422M0 10.864h2.543c.233 0 .422-.189.422-.422 0-.233-.189-.421-.422-.421H0v.843zM1.41 8.37c0-.234-.189-.423-.422-.423H0v.845h.988c.233 0 .422-.19.422-.423M1.41 27.024c0-.233-.189-.422-.422-.422H0v.844h.988c.233 0 .422-.19.422-.422M1.41 14.588c0-.233-.189-.422-.422-.422H0v.844h.988c.233 0 .422-.19.422-.422M2.543 28.675H0v.843h2.543c.233 0 .422-.188.422-.421 0-.233-.189-.422-.422-.422M2.543 16.239H0v.843h2.543c.233 0 .422-.188.422-.421 0-.233-.189-.422-.422-.422M2.543 22.457H0v.843h2.543c.233 0 .422-.188.422-.421 0-.233-.189-.422-.422-.422M0 6.719H.99c.233 0 .422-.19.422-.422 0-.234-.19-.422-.422-.422H0v.844zM.988 12.093H0v.843h.988c.233 0 .422-.188.422-.42 0-.234-.189-.423-.422-.423",
    transform: "translate(.957 .003)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScool);
export default __webpack_public_path__ + "static/media/scool.7da2b5379fa08094770ef60c54682ee9.svg";
export { ForwardRef as ReactComponent };